import 'waypoints/lib/noframework.waypoints'
import lottie from 'lottie-web'
import animationData from '../../lottie/product-info-swoosh.json'
import debounce from 'debounce'
class ProductInfo {
  constructor (el) {
    this.el = el
    this.navigationItems = el.querySelectorAll('.js-product-info-navigation__item')
    this.imageSets = el.querySelectorAll('.js-product-info-images__set')
    this.swooshContainer = el.querySelector('.js-product-info__swoosh')
    this.dots = el.querySelectorAll('.js-product-info-dot')
    this.navigation = el.querySelector('.js-product-info-navigation')
    this.navigationHeight = this.navigation.offsetHeight
    
    const resize = debounce(() => {
      this.resize()
    }, 250)

    resize()
    window.addEventListener('resize', () => {
     resize() 
    })
    /* eslint-disable-next-line no-undef */
    new Waypoint({
      element: el,
      handler: () => {
        if(el.classList.contains('product-info--animated')) return

        this.animateIn()
        this.addEventListeners()
        this.setupSwoosh()
        el.classList.add('product-info--animated')
      },
      offset: '75%',
    })
  }

  resize() {
    this.navigation.style.minHeight = '240px'

    const windowWidth = window.innerWidth
    if(windowWidth < 992) return

    this.navigation.style.minHeight = `${this.navigationHeight + 180}px`
   
  }
  addEventListeners () {
    // desktop navigation
    this.navigationItems.forEach(item => {      
      const key = item.getAttribute('data-product-info-key')

      item.addEventListener('mouseenter', () => {
        const key = item.getAttribute('data-product-info-key')
        
        this.el.classList.add('product-info--hovering')
        this.imageSets[key].classList.add('product-info-images__set--hover')
        this.switchItem(key)
        clearInterval(this.interval)
      })

      item.addEventListener('mouseleave', () => {
        this.el.classList.remove('product-info--hovering')
        this.imageSets[key].classList.remove('product-info-images__set--hover')
        this.setupInterval()
      })
    })

    // mobile navigation 
    this.dots.forEach(item => {
      const key = item.getAttribute('data-product-info-key')
      item.addEventListener('click', () => {
        this.switchItem(key)
      })
    })
  }

  setupInterval() {
    this.interval = setInterval(() => {
      const nextItem = this.activeItem === this.navigationItems.length - 1 ? 0 : this.activeItem + 1
      this.activeItem = nextItem
      this.switchItem(this.activeItem)
    }, 5000);
  }

  animateIn() {
    this.el.classList.remove('product-info--animate')
    setTimeout(() => {
      this.navigationItems[0].classList.add('product-info-navigation__item--active')
      this.dots[0].classList.add('product-info-dots__dot--active')
      this.activeItem = 0
      this.setupInterval()

    }, 500);
  }

  setupSwoosh() {
    lottie.loadAnimation({
      container: this.swooshContainer,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: { 
        preserveAspectRatio:'none',
      },
    })
  }

  switchItem(key) {
    this.imageSets.forEach(set => { set.classList.remove('product-info-images__set--active') })
    this.navigationItems.forEach( item => { item.classList.remove('product-info-navigation__item--active') })
    this.dots.forEach( dot => { dot.classList.remove('product-info-dots__dot--active') })

    this.imageSets[key].classList.add('product-info-images__set--active')
    // this.imageSets[key].classList.remove('product-info-images__set--hover')
    this.navigationItems[key].classList.add('product-info-navigation__item--active')
    this.dots[key].classList.add('product-info-dots__dot--active')
  }
}


export default {
  
  init() {
    const elements = document.querySelectorAll('.js-product-info')
    
    if(!elements.length) return
    elements.forEach(el => {
      new ProductInfo(el)
    })
  },
}